// extracted by mini-css-extract-plugin
export default {"titleContainer":"PageTitle-styles__titleContainer___fBdLu","titleIcon":"PageTitle-styles__titleIcon___cAccL","title":"PageTitle-styles__title____LwKg"};